import React, { forwardRef } from 'react'

import useGetSetting from 'js/page/Widget/hooks/useGetSetting'
import { WidgetType } from 'js/page/Widget/types/WidgetType'

import ExternalSearchEdit from './ExternalSearchEdit'
import ExternalSearchView from './ExternalSearchView/ExternalSearchView'

export interface ExternalSearchSettings {
    title: string
}

const ExternalSearch = forwardRef(
    ({ guid, entity, isEditing, onSave }: WidgetType, ref) => {
        const getSetting = useGetSetting(entity)

        const settings = {
            title: getSetting('title', ''),
        }

        if (isEditing) {
            return (
                <ExternalSearchEdit
                    ref={ref}
                    guid={guid}
                    settings={settings}
                    onSave={onSave}
                />
            )
        }

        return <ExternalSearchView guid={guid} settings={settings} />
    },
)

ExternalSearch.displayName = 'ExternalSearch'

export default ExternalSearch
